import Container from "@mui/material/Container/Container";
import { RectangularTextButton } from "components/Base/Buttons";

export default function RegisterPaymentCancelled() {
  return (
    <Container>
      <h2>Payment method setup was cancelled</h2>
      <p>You will be prompted to add a payment method once you login.</p>

      <RectangularTextButton
        colour="highlighted"
        buttonSize="large"
        href="/login/"
        sx={{
          borderRadius: "9999px",
          px: 4,
          py: 1.5,
          fontSize: "1rem",
          boxShadow: "0px 10px 30px rgba(0,0,0,0.35)",
        }}
      >
        Go to login.
      </RectangularTextButton>
    </Container>
  );
}